var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconMoreMenu = ({
  title,
  titleId,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 18,
  height: 18,
  viewBox: "0 0 18 18",
  xmlns: "http://www.w3.org/2000/svg",
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
  fill: "#348CFD",
  cx: 5.625,
  cy: 9,
  r: 1.125
}), /*#__PURE__*/React.createElement("circle", {
  fill: "#348CFD",
  cx: 9,
  cy: 9,
  r: 1.125
}), /*#__PURE__*/React.createElement("circle", {
  fill: "#348CFD",
  cx: 12.375,
  cy: 9,
  r: 1.125
}), /*#__PURE__*/React.createElement("circle", {
  stroke: "#348CFD",
  cx: 9,
  cy: 9,
  r: 8.5
})), /*#__PURE__*/React.createElement("path", {
  d: "M-1-1h20v20H-1z"
}))));
export { SvgIconMoreMenu as ReactComponent };
export default __webpack_public_path__ + "assets/images/icon-more-menu.svg";